/**
 * Prevents the page from scrolling when the user wheels past the top or
 * bottom boundary of a dropdown list panel.  Bind to the `(wheel)` event
 * on the scrollable overlay container.
 */
export function containDropdownWheel(event: WheelEvent): void {
  const el = event.currentTarget as HTMLElement;
  const atTop = el.scrollTop <= 0;
  const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;
  if ((atTop && event.deltaY < 0) || (atBottom && event.deltaY > 0)) {
    event.preventDefault();
  }
}
